import ReportDashboard from "../components/accounting-reports/ReportDashboard";

const AccountingReportPage = () => {
  return (
    <>
      <ReportDashboard />
    </>
  );
};

export default AccountingReportPage;
